import { render, staticRenderFns } from "./MemberShipChatWindow.vue?vue&type=template&id=62dedf47&scoped=true"
import script from "./MemberShipChatWindow.vue?vue&type=script&lang=js"
export * from "./MemberShipChatWindow.vue?vue&type=script&lang=js"
import style0 from "./MemberShipChatWindow.vue?vue&type=style&index=0&id=62dedf47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dedf47",
  null
  
)

export default component.exports